import { List, ListItem } from 'components/chroma';
import React from 'react';
import { replaceSpaces } from 'scenes/common/helpers/text';
import { useIsLargeScreen } from 'scenes/common/hooks/useMedia';
import styled from 'styled-components';
import { listItems } from '../../Footer/components';

const ClaimsCVPMobileWrapper = styled.div`
  margin-top: -0.5rem;
  margin-bottom: 1.5rem;
`;

export const ClaimsCVPMobile = () => {
  const isLargeScreen = useIsLargeScreen();

  if (isLargeScreen) return null;

  return (
    <ClaimsCVPMobileWrapper>
      <b>Our claims support</b>
      <List bullet>
        {listItems.map((benefit) => (
          <ListItem key={replaceSpaces(benefit.props.listkey)}>
            {benefit}
          </ListItem>
        ))}
      </List>
    </ClaimsCVPMobileWrapper>
  );
};
